import { FrontTicketPurchaseOfferResponseDto } from '@/lib/jp-api/requests';

export function isFutureOffer(offer: FrontTicketPurchaseOfferResponseDto): boolean {
  const now = new Date();
  if (!offer.starts) return false;
  return new Date(offer.starts).getTime() > now.getTime();
}
